export default __webpack_public_path__ + "static/media/holiday-item.16a70437.svg";